import { deserializeSuperjson } from '@lib/superjson';
import { CurrentTeam } from '@snap-types/actions/current-team';
import { buildTeamUrl } from '@ui/store/api-builder/build-team-url';
import { buildSiteUrl } from '@ui/store/api-builder/build-url';
import {
  enhanceEndpoints,
  injectEndpoints,
} from '@ui/store/api-builder/inject-mutation';

const injectedApi = injectEndpoints({
  endpoints: (builder) => ({
    getSnapSiteConfig: builder.query<
      CurrentTeam,
      { siteCode: string; siteUuid?: string; teamUuid?: string }
    >({
      transformResponse: deserializeSuperjson,
      query: ({ siteCode, siteUuid, teamUuid }) => {
        if (teamUuid) {
          if (!siteUuid) {
            throw new Error('Site UUID is required for team UUID');
          }
          return `${buildTeamUrl({ siteUuid, teamUuid })}/snap-team-config`;
        }

        // NOTE: The siteCode based path is for legacy support only until
        // ALL api calls use the siteUuid/teamUuid based paths
        return `${buildSiteUrl(siteCode)}/snap-site-config`;
      },
      providesTags: (_result, _error, args) => [
        { type: 'GetSnapSiteConfig', id: args.siteUuid },
      ],
    }),
  }),
});

enhanceEndpoints({
  addTagTypes: ['GetSnapSiteConfig'],
});

declare module '@ui/store/data' {
  interface ApiTagTypesMap {
    GetSnapSiteConfig: 'GetSnapSiteConfig';
  }
}

const getSnapSiteConfig = injectedApi.endpoints.getSnapSiteConfig;

export const useGetSnapSiteConfigQuery = getSnapSiteConfig.useQuery;
